import React from "react";
import styled from "@emotion/styled";
import { ClearedStyleRouterLink } from "@modules/Components";
import DefaultOrangeButton from "@modules/Components/DefaultOrangeButton";

const EmptyHeader = styled.h1`
  font-size: 24px;
  font-weight: bold;
  line-height: 1.5;
  color: #1f2021;
  margin-top: 44px;
  margin-bottom: 22px;

  @media (max-width: 400px) {
    font-size: 23px;
  }
`;

const EmptyP = styled.div`
  font-size: 16px;
  line-height: 1.88;
  color: #777984;
  margin-bottom: 38px;

  @media (max-width: 400px) {
    font-size: 15px;
  }
`;

const EmptyImageContainer = styled.div`
  height: auto;
  width: 189px;
  margin: 0 auto;
  min-height: 125px;
`;

const EmptyImage = styled.img`
  width: 100%;
  height: auto;
`;

const CartNoCardsFound = () => {
  return (
    <>
      <EmptyImageContainer>
        <EmptyImage
          src="https://cdn.cardcash.com/website/ui/elements/empty_cart.png"
          alt="bird empty cup"
        />
      </EmptyImageContainer>
      <EmptyHeader>Looks like you didn't add anything to the cart</EmptyHeader>
      <EmptyP>Once you add something, it will appear here.</EmptyP>
      <ClearedStyleRouterLink to="/buy-gift-cards/">
        <DefaultOrangeButton>
          <span>Browse giftcards</span>
        </DefaultOrangeButton>
      </ClearedStyleRouterLink>
    </>
  );
};

export default CartNoCardsFound;
